import React from "react";

import Button, { ButtonProps } from "@mui/material/Button";
import styled from "@mui/material/styles/styled";
import MuiTab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import Stack from "@rui/Stack";

export const SidebarHeaderContainer = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

export const SidebarTab = styled(MuiTab)(({ theme }) => ({
  ...theme.typography.bodySecondaryMed,
  minHeight: "26px",
  height: "26px",
  color: theme.palette.shades.neutral[500],
  borderRadius: "6px",
  padding: "4px",
  minWidth: 0,
  "&:not(:last-of-type)": {
    marginRight: theme.spacing(1.5),
  },

  "&:hover": {
    color: theme.palette.shades.neutral[700],
  },

  "&.Mui-selected": {
    background: "none !important",
    color: theme.palette.shades.neutral[800],
  },

  "&.Mui-disabled": {
    fontWeight: 400,
    color: theme.palette.shades.neutral[300],
  },
}));

export const OverviewHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.labelMed,
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[500],
  fontWeight: 700,
  marginBottom: theme.spacing(2),
}));

export const EmptyOverviewText = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryReg,
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[300],
  fontStyle: "italic",
}));

export const OverviewSection = styled(Stack)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
  "&:not(:first-of-type)": {
    paddingTop: theme.spacing(2),
    borderTop: "1px solid",
    borderColor: theme.palette.shades.neutral[100],
  },
}));

export const SourcesList = styled(Stack)(({ theme }) => ({
  overflowY: "auto",
  padding: theme.spacing(1, 3, 3),
  [theme.breakpoints.up("md")]: {
    paddingBottom: theme.spacing(6), // extra space for the feedback buttons
  },
}));

export const OverviewButton = styled<React.FC<ButtonProps>>((props) => (
  <Button variant="outlined" disabled {...props} />
))(({ theme }) => ({
  padding: theme.spacing(1),
  borderColor: theme.palette.shades.neutral[100],
  backgroundColor: "#FFF",
  borderRadius: "8px",
  color: theme.palette.shades.neutral[800],
  boxShadow: "0px 1px 16px 0px #231F380A",
  minWidth: 0,
  width: "fit-content",
  "&.Mui-disabled": {
    color: theme.palette.shades.neutral[800],
  },
  "& .MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: theme.spacing(0.5),
  },
  "& .MuiSvgIcon-root": {
    fontSize: "12px",
    color: theme.palette.shades.neutral[200],
  },
}));
